module.exports = __webpack_public_path__ + "media/images/flags/32/Nicaragua-851b925f6be10c71f73f71cf638909d1.png";